// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"59823f97","977":"c90cb733"}[chunkId] + ".chunk.js";
};